module.exports = __webpack_public_path__ + "static/img/dj1-2.76fe6f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/dj1-2.png
// module id = 786
// module chunks = 0